module.exports = __webpack_public_path__ + "img/attraction3.172c3e29.jpg";